import {createAsyncThunk} from '@reduxjs/toolkit';

import {subscriptionService} from 'api/subscription';

export const getCompanySubscriptions = createAsyncThunk('company/getSubscriptions', async (companyId: string) => {
  return subscriptionService.getSubscriptions(companyId);
});

export const getProPlans = createAsyncThunk('profile/getProPlan', async () => {
  return subscriptionService.getProPlan();
});
